module.exports = __webpack_public_path__ + "img/right-int.30afaef9.svg";